import {
	type PropsForRoute,
	type RouteName,
	typedUrlForRoute,
	useTypedNavigation,
} from "$root/components/PlatformRouter/RoutesDef";
import { ActionText, Row } from "@mdotm/shadcn/legacy/components";

export type RouteProps<K extends RouteName> = { target: K; params: PropsForRoute<K> };
function InvestmentName<K extends RouteName>({
	name,
	nofInstruments,
	openInNewTab,
	url,
}: {
	name: string;
	nofInstruments?: number;
	openInNewTab?: boolean;
	url: { target: K; params: PropsForRoute<K> };
}): React.JSX.Element {
	const { push } = useTypedNavigation();
	return (
		<Row className="h-full w-full" alignItems="center">
			<div className="flex flex-1 w-[calc(100%-162px)]">
				<div className="inline-flex items-center gap-1 w-full">
					<ActionText
						className="font-medium truncate items-center"
						onClick={() => {
							if (openInNewTab && url) {
								window.open(typedUrlForRoute(url.target, url.params), "_blank");
								return;
							}

							if (url) {
								push(url.target, url.params);
							}
						}}
					>
						{name}
					</ActionText>
					{openInNewTab && (
						<svg
							width="12"
							height="12"
							viewBox="0 0 12 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							className="shrink-0"
						>
							<path
								d="M8 1.5H10.5V4"
								stroke="currentColor"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M7 5L10.5 1.5"
								stroke="currentColor"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M8.5 7.4375V9.625C8.5 10.1084 8.10844 10.5 7.625 10.5H2.375C1.89156 10.5 1.5 10.1084 1.5 9.625V4.375C1.5 3.89156 1.89156 3.5 2.375 3.5H4.5625"
								stroke="currentColor"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					)}
				</div>
			</div>
			{nofInstruments != null && <p className="font-semibold">{nofInstruments} ins.</p>}
		</Row>
	);
}

export default InvestmentName;
